import React from "react"
import { useQuery } from "react-query"
import { Flex, Text, INNER_MAX_WIDTH, Button } from "@capioweb/ui-components"
import { LocalesContext } from "../../context"
import { getContent } from "../../api/content"
import { PUBLIC_API_ENDPOINT, queryStaleTime } from "../../constants"
import { SiteSettingsProps } from "../../components/Core"
import { Logo404 } from "./assets/Logo404"
import { sendAppDownloadDataLayerPush } from "../../utils/piwikPro"

const NotFound404: React.FC = () => {
	const { translate, translationKeys } = React.useContext(LocalesContext)

	// Site settings query
	const { data: siteSettingsData, isLoading } = useQuery<SiteSettingsProps>(
		"site",
		() => getContent(`${PUBLIC_API_ENDPOINT}/settings/site/`),
		{
			staleTime: queryStaleTime,
		}
	)

	return (
		<Flex display="block" w={1} maxw={552 / 8} m="auto">
			{!isLoading && siteSettingsData && (
				<Flex as="section" minh={70} px={3} py={10}>
					<Flex
						alignItems="center"
						flexDirection="column"
						w={1}
						maxw={INNER_MAX_WIDTH}
						style={{ margin: "0 auto" }}
					>
						<Flex mb={3}>
							<Logo404 />
						</Flex>
						{siteSettingsData.notFoundHeading && (
							<Text variant="headline-1">
								{siteSettingsData.notFoundHeading}
							</Text>
						)}
						{siteSettingsData.notFoundPreamble && (
							<Text variant="paragraph-16">
								{siteSettingsData.notFoundPreamble}
							</Text>
						)}
						{siteSettingsData.notFoundLinks &&
						siteSettingsData.notFoundLinks &&
						siteSettingsData.notFoundLinks?.length > 0 ? (
							<Flex w={1} flexDirection={{ _: "column", m: "row" }} mt={1}>
								{siteSettingsData.notFoundLinks.map((item) => (
									<Flex w={1}>
										<Button.Anchor
											href={item.href}
											target={item.target}
											title={item.title}
											variant="navy"
											m={{ _: "24px auto", m: "auto" }}
											style={{ width: "80%" }}
										>
											{item.text}
										</Button.Anchor>
									</Flex>
								))}
							</Flex>
						) : (
							<Flex w={1} flexDirection={{ _: "column", m: "row" }} mt={1}>
								{siteSettingsData.appAppleStoreUrl?.href && (
									<Flex w={1}>
										<Button.Anchor
											onClick={() => sendAppDownloadDataLayerPush("ios")}
											href={siteSettingsData.appAppleStoreUrl.href}
											variant="navy"
											m={{ _: "24px auto", m: "auto" }}
											style={{ width: "80%" }}
										>
											{translate(translationKeys.appStore)}
										</Button.Anchor>
									</Flex>
								)}
								{siteSettingsData.appGooglePlayStoreUrl?.href && (
									<Flex w={1}>
										<Button.Anchor
											onClick={() => sendAppDownloadDataLayerPush("android")}
											href={siteSettingsData.appGooglePlayStoreUrl.href}
											variant="navy"
											m="auto"
											style={{ width: "80%" }}
										>
											{translate(translationKeys.googlePlay)}
										</Button.Anchor>
									</Flex>
								)}
							</Flex>
						)}
					</Flex>
				</Flex>
			)}
		</Flex>
	)
}

export { NotFound404 }
